document.ontouchmove = function (event) {
    var isTouchMoveAllowed = false;
    var p = event.target;

    while (!isTouchMoveAllowed && p != null) {
        isTouchMoveAllowed = p.classList && (p.classList.contains("touchMoveAllowed") || p.classList.contains("md-select-menu-container") || p.classList.contains("md-autocomplete-suggestions-container"));

        p = p.parentNode;
    }

    if (!isTouchMoveAllowed) {
        event.preventDefault();
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/app/onTouchMove.js
 ** module id = 194
 ** module chunks = 0
 **/